import CsvImportPage from "./CsvImportPage";
import CustomFilterNotification from "./CustomFilterNotification";
import SingleUserNotification from "./SingleUserNotification";
import VenueNotification from "./VenueNotification";

type Props = {
  currentSelectedTab: string;
  scheduleNotifications: string;
  notificationScheduleTime: Date;
  refetch: () => void;
};

const RenderSendToContainer = ({
  currentSelectedTab,
  scheduleNotifications,
  notificationScheduleTime,
  refetch,
}: Props) => {
  if (currentSelectedTab === "single-user") {
    return (
      <SingleUserNotification
        scheduleType={scheduleNotifications}
        notificationScheduleTime={notificationScheduleTime}
        refetch={refetch}
      />
    );
  }

  if (currentSelectedTab === "whole-venue") {
    return (
      <VenueNotification
        scheduleType={scheduleNotifications}
        notificationScheduleTime={notificationScheduleTime}
        refetch={refetch}
      />
    );
  }

  if (currentSelectedTab === "custom-filter") {
    return (
      <CustomFilterNotification
        scheduleType={scheduleNotifications}
        notificationScheduleTime={notificationScheduleTime}
        refetch={refetch}
      />
    );
  }
  if (currentSelectedTab === "csv-import") {
    return <CsvImportPage refetch={refetch} />;
  }

  return <>cant find selected tab</>;
};

export default RenderSendToContainer;
